/**
 * Minimal ABI for Circle CCTP V2 TokenMessengerV2 contract.
 *
 * V2 depositForBurn has 7 params (vs V1's 4):
 *   - amount, destinationDomain, mintRecipient, burnToken (same as V1)
 *   - destinationCaller: bytes32(0) = anyone can call receiveMessage
 *   - maxFee: 0 for standard transfer (Circle charges minimum)
 *   - minFinalityThreshold: 2000 = standard, 1000 = fast
 *
 * Contract: 0x28b5a0e9C621a5BadaA536219b3a228C8168cf5d (same on all chains)
 * Source: https://github.com/circlefin/evm-cctp-contracts
 */
export const TokenMessengerV2Abi = [
  {
    name: 'depositForBurn',
    type: 'function',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'amount', type: 'uint256' },
      { name: 'destinationDomain', type: 'uint32' },
      { name: 'mintRecipient', type: 'bytes32' },
      { name: 'burnToken', type: 'address' },
      { name: 'destinationCaller', type: 'bytes32' },
      { name: 'maxFee', type: 'uint256' },
      { name: 'minFinalityThreshold', type: 'uint32' },
    ],
    outputs: [{ name: 'nonce', type: 'uint64' }],
  },
] as const;
